import { render } from "./DisplayPluginOptionsAPIProvider.vue?vue&type=template&id=fea99966"
import script from "./DisplayPluginOptionsAPIProvider.vue?vue&type=script&lang=js"
export * from "./DisplayPluginOptionsAPIProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__